export default {
  sanity_check: {
    title: 'AI Sanity Check',
    generate: 'Analyze Event',
    running: 'Analyzing...',
    generated_successfully: 'Event analysis completed successfully',
    empty_state: {
      title: 'No event analysis reports yet',
      subtitle: 'Click the Analyze Event button to check your event configuration for potential improvements.',
    },
    no_recommendations: {
      title: 'All clear!',
      subtitle: 'Your event configuration looks perfect. No improvements needed.',
    },
    topic_no_recommendations: 'No improvements needed for this section.',
    topics: {
      general: 'General Settings',
      submissionForm: 'Submission Form',
      registrationForm: 'Registration Form',
    },
    severity: {
      info: 'Info',
      warning: 'Warning',
      critical: 'Critical',
    },
  },
};
